import {
  addKeyboardListener,
  type KeyboardListenerHandle,
} from "@src/appV2/NativeAdapters/keyboard.adapter";
import { type RefObject, useEffect } from "react";

export function useScrollToViewOnKeyboard(
  elementRef: RefObject<HTMLElement | HTMLInputElement | undefined>
) {
  useEffect(() => {
    let keyboardDidShowListener: KeyboardListenerHandle | undefined;

    async function bindListeners() {
      keyboardDidShowListener = await addKeyboardListener("keyboardDidShow", () => {
        elementRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    void bindListeners();

    return () => {
      void keyboardDidShowListener?.remove();
    };
  }, [elementRef]);
}
